import { createContext, useContext, useState } from "react";
import APIContext from "../api/api";
import { URLS } from "../../configuration/urls";

const ParcelsContext = createContext();

const TODAY = new Date()?.toISOString()?.split("T")[0];

export const MAWBKPIProvider = ({ children }) => {
  const [mawbInfoCard, setMawbInfoCard] = useState(null);
  const [dScanMawb, setDScanMawb] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const apiContext = useContext(APIContext);
  const getData = apiContext?.getData;

  const fetchMawbParcelsData = async ({ id, onFinally }) => {
    if (!getData) {
      console.warn("API context not available yet");
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      const [mawbInfoCardResponse, dScanMawbResponse] = await Promise.all([
        getData(`h7/kpi/mawb/${id}`, {}, URLS.EC_CLEAR_CUSTOMS_BE()),
        getData(`h7/kpi/mawb/${id}/parcels`, {}, URLS.EC_CLEAR_CUSTOMS_BE())
      ]);
      setMawbInfoCard(mawbInfoCardResponse);
      if (Array.isArray(dScanMawbResponse))
        setDScanMawb(dScanMawbResponse || []);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
      onFinally?.();
    }
  };

  const value = {
    isLoading,
    error,
    fetchMawbParcelsData,
    mawbInfoCard,
    dScanMawb,
    refetch: () => fetchMawbParcelsData(TODAY, true)
  };

  return (
    <ParcelsContext.Provider value={value}>{children}</ParcelsContext.Provider>
  );
};

// Custom hook to use parcels context
export const useParcelsMawb = () => {
  const context = useContext(ParcelsContext);
  if (!context) {
    throw new Error("useParcels must be used within a OverallKPIProvider");
  }
  return context;
};
